export default {
  outlined: {
    width: 'calc(100% - 30.5px)',
  },
}
